export default __webpack_public_path__ + "static/media/elekipo.3c920224.png";